import { render, staticRenderFns } from "./BulkRecordImportModal.vue?vue&type=template&id=5de0aa4f&scoped=true"
import script from "./BulkRecordImportModal.vue?vue&type=script&lang=js"
export * from "./BulkRecordImportModal.vue?vue&type=script&lang=js"
import style0 from "./BulkRecordImportModal.vue?vue&type=style&index=0&id=5de0aa4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de0aa4f",
  null
  
)

export default component.exports